<!---触发记录--->
<template>
    <div class="page_content">
        <div class="main">
            <!-- 搜索区域 -->
            <div class="head">
                <div class="searchArea">
                    <div class="title">查询数据</div>
                    <div class="content">
                        <el-form style="width: 90%"  label-width="90px">
                            <el-row :gutter="24">
                                <el-col :span="8">
                                   <el-form-item label="选择设备：">
                                    <el-select v-model="selectedCodes" placeholder="请选择" size="small" multiple clearable>
                                        <el-option
                                        v-for="(item,index) in deviceList"
                                        :key="index"
                                        :label="item.name" :value="item.code"></el-option>
                                    </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="选择变量：">
                                    <el-select v-model="searchParams.params" placeholder="请选择" size="small" clearable>
                                        <el-option
                                        v-for="(item,index) in paramsList"
                                        :key="index"
                                        :label="item.name" :value="item.name"></el-option>
                                    </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="触发条件：">
                                        <el-select v-model="searchParams.condition" placeholder="请选择" size="small" clearable>
                                            <el-option
                                            v-for="(item,index) in triggerConditionList"
                                            :key="index"
                                            :label="item.value" :value="item.id"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="24">
                                <el-col :span="8">
                                    <el-form-item label="处理状态：">
                                    <el-select v-model="searchParams.is_use" placeholder="请选择" size="small">
                                        <el-option
                                        v-for="(item,index) in dealStatus"
                                        :key = "index"
                                        :label="item.label" :value="item.id"></el-option>
                                    </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="16">
                                    <el-form-item label="时间区间：">
                                    <el-date-picker
                                        v-model="datetimerange"
                                        type="datetimerange"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期"
                                        format="yyyy-MM-dd HH:mm:ss"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        size="small"
                                        @change="changeDate">
                                    </el-date-picker>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                        <div class="block"></div>
                        <div class="rightBtn">
                            <el-button type="primary" icon="el-icon-search" size="small" class="btnStyle" style="margin-bottom:0.1rem" @click="onSearch">查询</el-button>
                            <el-button icon="el-icon-refresh-left" size="small" style="margin-left: 0;" @click="resetting">重置</el-button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 表格区域 -->
            <div class="tableArea">
                <!-- 操作区域 -->
                <div class="option">
                    <div style="color:#405891;font-size:0.16rem;font-weight:600">
                        触发记录列表
                    </div>
                    <div>
                        <el-button type="primary" size="small" icon="el-icon-circle-check" class="btnStyle" @click="handleBatch()">多选处理</el-button>
                    </div>
                </div>
                <div class="showSelected" v-if="isShow">
                    <div>
                      <i class="el-icon-info"></i><span style="margin-left:0.1rem">已选中{{selectedRows.length}}项</span><span style="padding-left:20px">累计报警：{{totalWarning}}条</span>
                    </div>
                </div>
                <div class="table">
                    <el-table :data="tableData" style="width: 100%" :row-key="rowKey" :header-cell-style="{background:'#FAFAFA',color:'#405891'}" @selection-change="handleSelectionChange">
                        <el-table-column type="selection" width="55" :selectable="checkSelect" :reserve-selection="true"></el-table-column>
                        <el-table-column label="序号" width="80">
                        <template slot-scope="scope">
                            {{scope.$index+1}}
                        </template>
                        </el-table-column>
                        <el-table-column prop="aname" label="设备信息" width="180" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column prop="dcode"  width="220">
                        </el-table-column>
                        <el-table-column width="50">
                            <template slot-scope="scope">
                               <i v-if="scope.row.dcode" class="el-icon-document-copy" style="cursor:pointer" @click="copyBtn(scope.row.dcode)"></i>
                            </template>
                        </el-table-column>
                        <el-table-column prop="params" label="监控变量">
                        </el-table-column>
                        <el-table-column label="设定值">
                        <template slot-scope="scope">
                           {{getSetValue(scope.row)}}
                        </template>
                    </el-table-column>
                        <el-table-column prop="nowvalue" label="当前值">
                        </el-table-column>
                        <el-table-column prop="create_time" label="更新时间" width="200">
                        </el-table-column>
                        <el-table-column prop="v6" label="状态">
                            <template slot-scope="scope">
                                <div style="display:flex; align-items:center;">
                                    <span :style="{background:scope.row.is_use == 1? '#FF791A':'#75D391'}" style="display:inline-block;width:5px;height:5px;border-radius:50%;margin-right:0.1rem"></span>
                                    <span>{{scope.row.is_use == 1 ? '未处理':'已处理'}}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="total" label="累计报警">
                        <template slot-scope="scope">
                            <span>{{scope.row.total}}条</span>
                        </template>
                        </el-table-column>
                        <el-table-column label="操作" width="150" fixed="right">
                        <template slot-scope="scope">
                            <el-button style="color:#437EDE" type="text" @click="handleClick(scope.row)">立即处理</el-button>
                        </template>
                        </el-table-column>
                    </el-table>
                    <div style="margin-top:0.2rem;text-align:right;">
                        <a-pagination v-model="current" show-quick-jumper show-size-changer :page-size-options="pageSizeOptions" :total="totalCount" @change="onChange"  @showSizeChange="pageSizeChange" />
                    </div>
                </div>
            </div>
            <!-- 处理弹框 -->
            <el-dialog :visible.sync="dialogVisable" :title="dialogTitle" width=75%>
                <el-form label-width="80px" :inline="true" style="display:flex;justify-content:space-around">
                    <el-form-item label="处理状态">
                        <el-select v-model="dialogForm.value1" placeholder="请选择" size="small" @change="dialogSearch" clearable>
                        <el-option
                            v-for="(item,index) in dealStatus"
                            :key = "index"
                            :label="item.label" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="时间区间">
                        <el-date-picker
                            v-model="dialogForm.value2"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            size="small"
                            @change="dialogDatePicker">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button icon="el-icon-edit" type="primary" size="small" class="btnStyle" @click="handleBatch">一键处理</el-button>
                    </el-form-item>
                </el-form>
                <el-table :data="dialogTableData" :row-key="rowKey" :header-cell-style="{background:'#FAFAFA',color:'#405891'}"  @selection-change="handleSelectionChange">
                    <el-table-column type="selection" :selectable="checkSelect" :reserve-selection="true"></el-table-column>
                    <el-table-column label="序号">
                    <template slot-scope="scope">
                        {{scope.$index+1}}
                    </template>
                    </el-table-column>
                    <el-table-column prop="create_time" label="更新时间" width="150"></el-table-column>
                    <el-table-column prop="params" label="监控变量"></el-table-column>
                    <el-table-column  label="设定值">
                        <template slot-scope="scope">
                           {{getSetValue(scope.row)}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="nowvalue" label="当前值"></el-table-column>
                    <el-table-column prop="push_info" label="报警内容" show-overflow-tooltip></el-table-column>
                    <el-table-column label="状态">
                    <template slot-scope="scope">
                        <div style="display:flex; align-items:center;">
                            <span :style="{background:scope.row.is_use == 1? '#FF791A':'#75D391'}" style="display:inline-block;width:5px;height:5px;border-radius:50%;margin-right:0.1rem"></span>
                            <span>{{scope.row.is_use == 1 ? '未处理':'已处理'}}</span>
                        </div>
                    </template>
                    </el-table-column>
                    <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button style="color:#437EDE" type="text"  @click="handleDeal(scope.row)" :disabled="scope.row.is_use==2">立即处理</el-button>
                    </template>
                    </el-table-column>
                </el-table>
                <div style="margin-top:0.2rem;text-align:right">
                    <a-pagination v-model="current1" shwo-less-items :total="dialogTotalCount" @change="onChange1" />
                </div>
            </el-dialog>

            <!-- 处理备注弹框 -->
            <el-dialog :visible.sync="handleSuccessDialog" title="填写备注" width="30%">
                <!-- <div slot="title" class="dialogTitle">
                    <i class="el-icon-success"></i><span style="margin-left:0.1rem">处理成功</span>
                </div> -->
                <div style="display:flex">
                    <div style="width: 120px">备注内容：</div><el-input type="textarea" placeholder="请输入内容" v-model="processRemark"></el-input>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="handleSuccessDialog= false" size="small">取 消</el-button>
                    <el-button type="primary" @click="saveOperation" size="small" class="btnStyle">保存</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import { getAreaList } from '@/api/page/deviceList.js'
import { getTriggerRecordsList, getDeviceParams, handleTriggerRecord} from '@/api/page/triggerRecord.js'
export default {
    data() {
        return {
            // 搜索参数
            searchParams:{
              codes:"",
              params:'全部',
              condition: 0,
              is_use: 0,
              min_time:'',
              max_time:'',
              aname:'',
            },
            selectedCodes:[],// 选择的设备列表
            datetimerange:[],
            // 处理状态
            dealStatus: [{
               id: 0,
               label: '全部'
            },{
               id: 1,
               label: '未处理'
            },{
               id: 2,
               label: '已处理'
            }],
             // 变量
            paramsList:[],
            deviceList:[],
            tableData:[],
            page: 1,
            limit: 10,
            totalCount: null,
            current:1,
            current1:1,

            dialogVisable: false, // 立即处理弹框
            dialogTableData: [], //立即处理弹框数据
            dialogTitle: '立即处理',
            dialogCode: '',
            dialogStatus: '全部',
            dialogTotalCount:null,
            dialogPage:1,
            dialogLimit:8,
            dealIds: '',
            dialogForm: {
                value1:'',
                value2: '',
                min_time:'',
                max_time:'',
            },
            handleSuccessDialog:false,
            pageSizeOptions: ['10','20','30','40','50'],
            processRemark:'',
            selectedRows: [], // 选中的行数据
            totalWarning: 0, // 选中行累计报警数
            isShow: false
        }
    },
    mounted() {
        this.getDeviceList()
        this.getDeviceParams()
        this.getTriggerRecordsList()
    },
    methods:{
         // 获取设备列表
        getDeviceList() {
          let self = this;
          let data = {
            account: window.localStorage.getItem('account'),
            is_all: 1,
            is_gkz: 2,
            token: window.localStorage.getItem('token'),
            ts:this.stringTime(new Date())
          };
          getAreaList(data).then(res=> {
            self.deviceList = res.data
            // self.deviceList.unshift({
            //     name: '全部',
            //     code: '0',
            // })
          })
        },
         // 获取变量
        getDeviceParams() {
            let self = this;
            let data = {
            account: window.localStorage.getItem('account'),
            token: window.localStorage.getItem('token'),
            ts:this.stringTime(new Date())
            }
            getDeviceParams(data).then(res=> {
            self.paramsList = res.data
            self.paramsList.unshift({
                name: '全部',
            })
            })
        },
        // 获取触发记录列表
        getTriggerRecordsList() {
            let self = this;
            let data = {
                account: window.localStorage.getItem('account'),
                token: window.localStorage.getItem('token'),
                page: self.page,
                limit: self.limit,
                codes: self.searchParams.codes,
                params: self.searchParams.params == '全部'? '': self.searchParams.params,
                condition: self.searchParams.condition,
                is_use: self.searchParams.is_use,
                min_time: self.searchParams.min_time,
                max_time: self.searchParams.max_time,
                ts:this.stringTime(new Date())
            }
            getTriggerRecordsList(data).then(res=> {
               self.tableData = res.data
               self.totalCount = res.meta.total_count
            })
         },
        getSetValue(item) {
            if(item.condition ==1 ||item.condition ==2) {
                let setValue = `A=${item.A}`
                return setValue
            } else {
                let setValue = `A=${item.A}  B=${item.B}`
                return setValue
            }
        },
        onSearch() {
          this.page = 1
          this.limit = 10
          this.getTriggerRecordsList()
        },
        handleSelectionChange(val) {
            this.selectedRows = val
            let ids = []
            val.forEach(item => {
                ids.push(item.id)
            });
           this.dealIds = ids.join(',')
        },
        // 批量处理
        handleBatch() {
          if(!this.dealIds) {
            this.$message.warning('请选择需要处理的触发记录')
            return
          }
          this.handleSuccessDialog = true;
        },
        // 立即处理
        handleClick(item) {
          this.dialogTitle = item.aname
          this.dialogVisable = true;
          this.dialogCode = item.dcode;
          this.getDialogTable(item)
        },
        rowKey(row) {
          return row.id
        },
        getDialogTable() {
           let data = {
               account: window.localStorage.getItem('account'),
               codes: this.dialogCode,
               page: this.dialogPage,
               limit: this.dialogLimit,
               is_use: this.dialogStatus == '全部'? '':this.dialogStatus,
               min_time: this.dialogForm.min_time,
               max_time: this.dialogForm.max_time,
               token: window.localStorage.getItem('token'),
               ts:this.stringTime(new Date())
          }
          getTriggerRecordsList(data).then(res=> {
            this.dialogTableData = res.data
            this.dialogTotalCount = res.meta.total_count
          })
        },
        handleDeal(item) {
            this.dealIds = item.id;
            this.handleSuccessDialog = true;
        },
        saveOperation() {
            let data = {
                account: window.localStorage.getItem('account'),
                token: window.localStorage.getItem('token'),
                beizhu: this.processRemark,
                ids: this.dealIds,
                ts:this.stringTime(new Date())
            }
           handleTriggerRecord(data).then(res=> {
            if(res.meta.message == 'success') {
                this.$message.success('处理成功')
                this.handleSuccessDialog = false
                this.dealIds =''
                this.getDialogTable();
                this.getTriggerRecordsList();
            }
           })
        },
        onChange(val) {
          this.page = val
          this.getTriggerRecordsList()
        },
        onChange1(val) {
            this.dialogPage = val
            this.getDialogTable()
        },
        changeDate(val) {
            this.searchParams.min_time = val[0]
            this.searchParams.max_time = val[1]
        },
        pageSizeChange(page,pageSize) {
          this.page = page
          this.limit = pageSize
          this.getTriggerRecordsList()
       },
         // 重置
        resetting() {
            this.searchParams = {
                codes:"",
                params:'全部',
                condition: 0,
                is_use: 0,
                min_time:'',
                max_time:'',
            }
            this.getTriggerRecordsList()
       },
       dialogSearch(val) {
        this.dialogStatus = val
        this.getDialogTable()
       },
       dialogDatePicker(val) {
        if(this.isNull(val)) {
            this.dialogForm.min_time = ''
            this.dialogForm.max_time = ''
            this.getDialogTable()
            return
        }
        this.dialogForm.min_time = val[0]
        this.dialogForm.max_time = val[1]
        this.getDialogTable()
       },
       checkSelect(row) {
         if(row.is_use ==2) {
            return false
         } else {
            return true
         }
       },
    },
    watch: {
      selectedCodes:{
        handler(val) {
            let arr = val.join(',')
            this.searchParams.codes = arr
        }
      },
      selectedRows(val) {
        this.$nextTick(()=> {
            this.isShow = val.length>0 ? true: false
        })
        this.totalWarning = 0
        val.forEach(item=> {
            this.totalWarning += item.total
            console.log('ppp',item.total);
        })
      }
    },
    computed: {
        triggerConditionList(){
            return this.$store.state.triggerConditionList
        },
    }

}
</script>
<style lang="less" scoped>
    // 搜索框
    ::v-deep .el-form-item {
        margin-bottom: 0.1rem;
        .el-form-item__label {
            color: #405891;
        }
    }
    ::v-deep .el-input-group__append, .el-input-group__prependtyle {
        background: #437ede;
        border-color: #437ede;
        color: #fff;
    }

    .rightBtn {
        display: flex;
        flex-direction: column;
    }
    ::v-deep .el-radio {
        display:inline-block;
        margin-top: 10px;
    }
    .successDialog  ::v-deep .el-dialog {
        .el-dialog__header {
           background: #75D391 !important;
           color: #fff;
           font-size: 0.18rem;
        }
        .el-icon-close:before {
           color: #fff;
        }
    }
    ::v-deep .el-select {
      width: 100%;
    }
    ::v-deep .el-range-editor--small.el-input__inner {
      width: 100%;
    }
</style>
